import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    mobile = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.notice.sendRegisterVerifyCode, {
        mobile,
    }, options);
    if (error) return { error, status };
    return content || { codeId: '', info: '' };
};
